import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import { hot } from 'react-hot-loader';

function Signatures() {
	return (
		<>
			<p className="justify">
				<Trans i18nKey="loan_agreement.signatures">
					<strong>Signatures</strong>
				</Trans>
			</p>
			<p className="justify">
				<Trans i18nKey="loan_agreement.signatures_witness">
					<strong>IN WITNESS WHEREOF, </strong>the PARTIES have executed this Loan Agreement Promissory Note
					at Place:____________________ on Date:_______________.
				</Trans>
			</p>
		</>
	);
}

export default hot(module)(withTranslation()(Signatures));
